module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "period-confirmation-viewer"
  }, [(_vm.period || true) ? _c('div', [_c('span', {
    class: _vm.period ? '' : 'disabled'
  }, [(!_vm.small) ? _c('OutlineButton', {
    attrs: {
      "label": "Ändra datum",
      "icon": "edit-blue",
      "iconscale": 1.5
    },
    on: {
      "click": function($event) {
        return _vm.openPriceList(_vm.unit)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'period-wrapper': true, disabled: (_vm.period && !_vm.period.free)
    }
  }, [(_vm.period) ? _c('div', {
    staticClass: "period-viewer"
  }, [_c('div', {
    staticClass: "week-viewer"
  }, [_vm._v("\n        v." + _vm._s(_vm._f("date")(_vm.period.date_arrival, 'week')) + "\n      ")]), _vm._v(" "), _c('icon', {
    attrs: {
      "name": "calendar-blue",
      "scale": 2.5
    }
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("dateRange")([_vm.period.date_arrival, _vm.period.date_departure], 'weekday', ' - '))))]), _c('br'), _vm._v("\n      " + _vm._s(_vm._f("dateRange")([_vm.period.date_arrival, _vm.period.date_departure], 'long', ' - ')) + "\n    ")], 1) : _c('div', {
    staticClass: "period-viewer"
  }, [_c('div', {
    staticClass: "week-viewer"
  }, [_vm._v("\n        ...\n      ")]), _vm._v(" "), _c('icon', {
    attrs: {
      "name": "calendar-blue",
      "scale": 2.5
    }
  }), _vm._v(" "), (_vm.checkAvailability) ? _c('b', [_vm._v("Laddar priset...")]) : _vm._e(), _vm._v(" "), (!_vm.checkAvailability) ? _c('b', [_vm._v("Laddar...")]) : _vm._e(), _c('br'), _vm._v("\n      ...\n    ")], 1), _vm._v(" "), (!_vm.small) ? _c('div', {
    staticClass: "price-viewer"
  }, [_vm._v("\n      Pris\n      "), (_vm.cartAccomodationObject && _vm.period && _vm.period.price) ? _c('b', [_vm._v(_vm._s(_vm._f("currency")((_vm.cartAccomodationObject && _vm.period && _vm.period.price))))]) : _c('b', [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (_vm.mandatory_cleaning_price) ? _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mandatory_cleaning_price) ? _c('div', {
    staticClass: "alert"
  }, [_c('p', [_vm._v("Detta boende har obligatoriskt slutstäd. Kostnaden (" + _vm._s(_vm._f("currency")(_vm.mandatory_cleaning_price / 2)) + " med RUT-avdrag) tillkommer utöver boendepriset.")])]) : _vm._e(), _vm._v(" "), (_vm.special_message) ? _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.special_message) ? _c('div', {
    staticClass: "alert",
    domProps: {
      "innerHTML": _vm._s(_vm.special_message)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.not_available_reason) ? _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.not_available_reason) ? _c('div', {
    staticClass: "alert"
  }, [_c('p', [_vm._v(_vm._s(_vm.not_available_reason) + " "), (!_vm.updating) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.fetch()
      }
    }
  }, [_vm._v("Testa igen")]) : _vm._e(), _vm._v(".")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.period && false) ? _c('div', [_vm._v("\n    Laddar information...\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c88c1fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/Accomodation/AccomodationPeriodConfirm.vue
// module id = 896
// module chunks = 0